<template>
  <div class="vip-card-group">
    <div class="inner_center">
      <div
        v-for="(vo,idx) in vipCardList"
        :key="vo.value"
        :class="vo.className"
        class="card-item"
      >
        <div class="card-header">
          <div class="title">{{ vo.LABEL }}</div>
          <div class="desc">{{ vo.desc }}</div>
        </div>
        <div class="card-content">
          <div class="price-box">
            <i class="icon_dollar">￥</i>
            <span class="price">{{ vo.PRICE }}</span>
            <span class="time">{{ vo.time }}</span>
          </div>
          <div
            class="buy"
            @click="buy(vo)"
          >
            <!--            {{ vo.value === 3 ? '敬请期待' : '立即开通' }}-->
            立即开通
          </div>
          <!--          <div class="hr"/>-->

          <div class="scene-hr">
            <div class="line"></div>
            <div class="scene-text">下载范围</div>
            <div class="line"></div>
          </div>

          <div class="scope-list down-scope">
            <span
              v-for="item in vo.downScope"
              class="scope-item down-scope-item">
              <i :class="[ 'iconfont', item.scope ? 'icon-gou3': 'icon-cha3' ]"/>
              {{ item.label }}
            </span>
          </div>

          <div class="scene-hr">
            <div class="line"></div>
            <div class="scene-text">权益保障</div>
            <div class="line"></div>
          </div>
          <div class="permission-list">
            <div
              v-for="(permItem,permIdx) in permission"
              :key="permItem.label"
              :class="[ 'permission-item', vipCardList[idx].permissionArr[permIdx] == 1 ? 'on' :'no' ] "
            >
              <div class="permission-lf">
                <i :class="['iconfont',permItem.iconClass]"/>
                {{ permItem.label }}
              </div>
              <div
                :class="[ 'permission-rt', vipCardList[idx].permissionArr[permIdx] == 1 ? 'on' :'no' ] "
              >
                {{ vipCardList[idx].descList[permIdx] }}
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BUSINESS_VIP_INFO,
  BUSINESS_VIP_MONTH_INFO,
  PERSON_QUARTER_INFO,
  PERSON_QUARTER_MONTH_INFO,
  PERSON_VIP_INFO
} from "@/constant/VIP";
import {permission} from "@/components/introduce/common/module";
import {COMPANY_ONLINE, COMPANY_All_PURPOSE} from "@/constant/VIP_COMPANY";
import {PERSON_VIP} from "@/constant/_Privately/Vip";
import {VIP_MANAGE} from "@/constant/VIP_MANAGE";

const vipCardList = [
  {

    value: 1,
    desc: '限个人学习交流使用',
    className: 'business-vip',
    time: '/月起',
    ...VIP_MANAGE.PERSON.INFO,
    ...VIP_MANAGE.PERSON.MONTH,
    LABEL: '个人VIP',
    descList: [
      '不可商用',
      '10张-海量/天',
      '支持',
      '支持',
      '仅限学习用途',
      '不含商业授权',
      '10个',
      '定制积分500/月',
      '企业专享',
    ],
    permissionArr: [0, 1, 1, 1, 1, 1, 1, 1, 0],
    downScope: [
      {
        label: "限时免费",
        scope: true
      },
      {
        label: "个人会员专享",
        scope: true
      },
      {
        label: "企业会员专享",
        scope: false
      }
    ],
  },
  /* {
     label: '商用VIP',
     value: 2,
     ID: BUSINESS_VIP_MONTH_INFO.ID,
     PARENT_ID: BUSINESS_VIP_MONTH_INFO.PARENT_ID,
     desc: BUSINESS_VIP_MONTH_INFO.USER_CROWD,
     className: 'business-vip',
     price: BUSINESS_VIP_MONTH_INFO.PRICE,
     time: '/月起',
     descList: [
       '个人可商用',
       '10张-海量/天',
       '支持',
       '支持',
       '线上线下全渠道',
       '1个',
       '20个',
       '定制积分1000/月',
       '企业专享',
     ],
     permissionArr: [1, 1, 1, 1, 1, 1, 1,1,0],
     downScope:['商用VIP专享','普通VIP专享','限时免费']
   },*/
  {
    label: '企业VIP',
    value: 3,
    ...VIP_MANAGE.COMPANY.INFO,
    ...VIP_MANAGE.COMPANY.All_PURPOSE_NEW,
    desc: '— 商用授权 尊享定制 —',
    LABEL: '企业VIP',
    className: 'company-vip',
    time: '/年起',
    descList: [
      '企业可商用',
      '200张-海量/年',
      '支持',
      '支持',
      '线上线下全渠道',
      '1-多家',
      '不限量',
      '定制积分 无上限',
      '企业专享',
    ],
    permissionArr: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    downScope: [
      {
        label: "限时免费",
        scope: true
      },
      {
        label: "个人会员专享",
        scope: true
      },
      {
        label: "企业会员专享",
        scope: true
      }
    ],
  }
]

export default {
  name: "VipCardGroup",
  data() {
    return {
      vipCardList,
      permission,
      BUSINESS_VIP_INFO, PERSON_VIP_INFO,
      COMPANY_All_PURPOSE
    }
  },
  methods: {
    buy(vipInfo) {
      /* if (vipInfo.ID === -1){
         return false;
       }*/
      this.$emit('buy', vipInfo)
    },
  }
}
</script>

<style lang="scss" scoped>

/* 卡片模型 */
@mixin CardItem($theme,$themeHover,$imgUrl) {
  position: relative;
  transition: all 0.3s ease-in-out;

  .card-header {
    @include BgImage(100%, 96px, $imgUrl)
  }
  .card-content {
    .buy {
      background-color: $theme;

      &:hover {
        background-color: $themeHover
      }
    }

    .permission-list {
      .permission-item {

        &.on {
          .permission-lf {
            i {
              color: $theme;
            }
          }

          .permission-rt {
            color: #424866;
          }
        }

        &.no {
          .permission-lf {
            i {
              color: rgba(66, 72, 102, 0.45);
            }
          }

          .permission-rt {
            color: rgba(66, 72, 102, 0.45);
          }
        }
      }
    }
  }

  &:hover {
    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 14px;
      border: 2px solid $themeHover;
    }

  }
}

.vip-card-group {
  position: absolute;
  top: 240px;
  left: 50%;
  transform: translateX(-50%);

  .inner_center {
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .card-item {
    width: 378px;
    height: 720px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 26, 0.1);
    border-radius: 14px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    &:first-child {
      margin-right: 63px;
    }

    .card-header {
      height: 96px;
      background: #35D0BA;
      border-radius: 14px 14px 0px 0px;
      text-align: center;
      color: #FFFFFF;

      .title {
        font-size: 20px;
        font-weight: bold;
        line-height: 27px;
        letter-spacing: 1px;
        margin-bottom: 4px;
        padding-top: 24px;
      }

      .desc {
        font-size: 13px;
        line-height: 18px;
      }
    }

    .card-content {
      padding: 0 32px;

      .price-box {
        font-weight: bold;
        color: #2D2B33;
        text-align: center;
        padding: 32px 0 25px;

        .icon_dollar {
          font-size: 14px;
          line-height: 19px;
        }

        .price {
          font-size: 48px;
          line-height: 44px;
        }

        .time {
          font-size: 16px;
          line-height: 21px;
        }
      }

      .buy {
        width: 314px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        border-radius: 10px;
        font-size: 16px;
        font-weight: bold;
        color: #FFFFFF;
        position: relative;
        z-index: 5;
      }

      .hr {
        border-bottom: 1px dashed #C5CBE6;
        margin: 31px 0 32px;
      }

      .permission-list {
        .permission-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;

          .permission-lf {
            color: #424866;
            display: flex;
            //align-items: center;
            justify-content: center;

            i {
              font-size: 18px;
              margin-right: 10px;
            }
          }


        }
      }

      .scene-hr {
        font-size: 14px;
        color: #71758C;
        line-height: 20px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 28px 0 18px;

        .scene-text {
          white-space: nowrap;
        }

        .line {
          display: inline-block;
          width: 110px;
          height: 1px;
          border-bottom: 1px dashed #C5CBE6;
        }
      }

      .scope-list {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: -4px;

        .scope-item {
          display: inline-block;
          //width: 64px;
          line-height: 22px;
          background: #F5F6FA;
          border-radius: 4px;
          padding: 0 6px;
          color: #424866;
          margin-right: 8px;
          font-size: 13px;
          flex-shrink: 0;

          &:last-child {
            margin-right: 0;
          }

        }
      }
    }

    &:hover {
      &.card-item {
        margin-top: -16px;
      }
    }


    &.person-vip {
      @include CardItem(#35D0BA, #53D7C4, 'introduce/person-vip-bg.png')
    }

    &.business-vip {
      @include CardItem(#6969FF, #7F7FFF, 'introduce/business-vip-bg.png')
    }

    &.company-vip {
      @include CardItem(#233E90, #435AA0, 'introduce/company-vip-bg.png');

      .card-header {
        color: #FFE198;
      }

      .card-content {
        .price-box {
          .price {
            /* font-size: 30px;
             font-weight: bold;
             color: #424866;
             line-height: 40px;*/
          }
        }
      }
    }


  }
}


.down-scope {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  white-space: nowrap;

  .down-scope-item {
    height: 24px;
    background: #F7F7F7;
    border-radius: 4px;
    padding: 0 8px;
    font-size: 13px;
    color: #424866;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 6px 0px 0;

    .iconfont {
      font-size: 14px;
      margin-right: 4px;

      &.icon-gou3 {
        color: #36D0BA;
      }

      &.icon-cha3 {
        color: #B5B6C2;
      }
    }


  }
}

</style>
